import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API } from '../../constants/app-service-constants';

@Injectable()
export class HeaderMainService {
  constructor(private http: HttpClient) {}

  getCount(): Observable<any> {
    return this.http.get(`${API.INBOX_COUNT}`);
  }
}
